import _ from "lodash";

export default {
    getSelectedCategory: state => state.selectedCategory,
    getMode: state => state.mode,
    getVersion: state => state.kind,
    getChannelGroupData: state => state.channelGroupData,
    getAlertSummaryData: state => {
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == "alert" })
        return state.channelGroupData[index].channels
    },
    getEventSummaryData: state => {
        let index = _.findIndex(state.channelGroupData, (o) => { return o.channelGroup == "event" })
        return state.channelGroupData[index].channels
    },
    getCategoryId: state => state.categoryId,
    getCategoryNum: state => state.categoryNum,
    getChannelTimeFrom: state => state.channelTimeFrom,
    getChannelTimeTo: state => state.channelTimeTo,
    getCustomChannelIds: state => state.customChannelIds,
}